import script from "./oasis-layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./oasis-layout.vue?vue&type=script&setup=true&lang=ts"

import "./oasis-layout.vue?vue&type=style&index=0&id=018979ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-018979ee"]])

export default __exports__